var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs.length > 0)?_c('ul',{staticClass:"my-tabs"},_vm._l((_vm.tabs),function(item){return _c('li',{key:item.paneName,staticClass:"my-tabs__item"},[_c('button',{class:{
                active: _vm.value === item.paneName,
                disabled: _vm.disabled
            },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.itemClick(item)}}},[_vm._v("\n            "+_vm._s(item.name)+"\n        ")])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }